import React from 'react'

const Usermanagement = () => {
  return (
    <div>Usermanagement</div>
  )
}

export default Usermanagement